/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис работы с камерами
 */

/**
 * Сервис работы с камерами
 */
export class CameraServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения количества связей камеры и квартиры.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetCameraRoomCount = (req?: GetCameraRoomCountRequestDto, init?: RequestInit): Promise<GetCameraRoomCountResponseDto> => {
    return fm.request<GetCameraRoomCountRequestDto, GetCameraRoomCountResponseDto>(`${this.host}/vc/api/v1/camera/room/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей камеры и квартиры.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetCameraRoomList = (req?: GetCameraRoomListRequestDto, init?: RequestInit): Promise<GetCameraRoomListResponseDto[]> => {
    return fm.list<GetCameraRoomListRequestDto, GetCameraRoomListResponseDto>(`${this.host}/vc/api/v1/camera/room/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения камеры.
   * Для owner, employee параметр scope.vc_company_id подставляется из токена.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetCamera = (req: GetCameraRequestDto, init?: RequestInit): Promise<GetCameraResponseDto> => {
    return fm.request<GetCameraRequestDto, GetCameraResponseDto>(`${this.host}/vc/api/v1/camera/${encodeURIComponent(req.uid)}${fm.buildQuery(req, ["uid"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка камер.
   * Для owner, employee параметр scope.vc_company_id подставляется из токена.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetCameraList = (req?: GetCameraListRequestDto, init?: RequestInit): Promise<GetCameraListResponseDto> => {
    return fm.request<GetCameraListRequestDto, GetCameraListResponseDto>(`${this.host}/vc/api/v1/camera/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения RTSP-ссылки по идентификатору камеры в vcfront.
   * Метод доступен для: admin, service.
   * Метод доступен для: ApiKey
   */
  GetCameraRtspUrlExternalId = (req: GetCameraRtspUrlExternalIdRequestDto, init?: RequestInit): Promise<GetCameraRtspUrlExternalIdResponseDto> => {
    return fm.request<GetCameraRtspUrlExternalIdRequestDto, GetCameraRtspUrlExternalIdResponseDto>(`${this.host}/vc/api/v1/camera/rtsp_url/external_id/${encodeURIComponent(req.externalId)}${fm.buildQuery(req, ["externalId"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод привязки камеры и квартиры.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  PutCameraRoomAttach = (req: PutCameraRoomAttachRequestDto, init?: RequestInit): Promise<PutCameraRoomAttachResponseDto> => {
    return fm.request<PutCameraRoomAttachRequestDto, PutCameraRoomAttachResponseDto>(`${this.host}/vc/api/v1/camera/${encodeURIComponent(req.data.cameraUid)}/room/${encodeURIComponent(req.data.orpon)}/${encodeURIComponent(req.data.roomNumber)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод отвязки камеры и квартиры.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  PutCameraRoomDetach = (req: PutCameraRoomDetachRequestDto, init?: RequestInit): Promise<PutCameraRoomDetachResponseDto> => {
    return fm.request<PutCameraRoomDetachRequestDto, PutCameraRoomDetachResponseDto>(`${this.host}/vc/api/v1/camera/${encodeURIComponent(req.data.cameraUid)}/room/${encodeURIComponent(req.data.orpon)}/${encodeURIComponent(req.data.roomNumber)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод пакетной привязки камер и квартир.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  PutCameraRoomAttachList = (req?: PutCameraRoomAttachListRequestDto, init?: RequestInit): Promise<PutCameraRoomAttachListResponseDto> => {
    return fm.request<PutCameraRoomAttachListRequestDto, PutCameraRoomAttachListResponseDto>(`${this.host}/vc/api/v1/camera/room/attach/list`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод пакетной отвязки камер и квартир.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  PutCameraRoomDetachList = (req?: PutCameraRoomDetachListRequestDto, init?: RequestInit): Promise<PutCameraRoomDetachListResponseDto> => {
    return fm.request<PutCameraRoomDetachListRequestDto, PutCameraRoomDetachListResponseDto>(`${this.host}/vc/api/v1/camera/room/detach/list`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления камеры.
   * Метод доступен для: admin, service, bti
   */
  DeleteCamera = (req: DeleteCameraRequestDto, init?: RequestInit): Promise<DeleteCameraResponseDto> => {
    return fm.request<DeleteCameraRequestDto, DeleteCameraResponseDto>(`${this.host}/vc/api/v1/camera/${encodeURIComponent(req.uid)}${fm.buildQuery(req, ["uid"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания камеры.
   * Метод доступен для: admin, service, bti
   */
  PostCamera = (req: PostCameraRequestDto, init?: RequestInit): Promise<PostCameraResponseDto> => {
    return fm.request<PostCameraRequestDto, PostCameraResponseDto>(`${this.host}/vc/api/v1/camera`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов камер
 */
export enum CameraType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Регистратор
   */
  DVR = "DVR",
  /**
   * Система управления видео
   */
  VMS = "VMS",
  /**
   * RTSP-камера
   */
  ROSE = "ROSE",
  /**
   * IP-камера
   */
  VIOLET = "VIOLET",
}
/**
 * Справочник типов камер
 */
export type CameraTypeResponseEnum = keyof typeof CameraType
/**
 * Справочник типов камер
 */
export type CameraTypeRequestEnum = Exclude<CameraTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum CameraPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type CameraPagingDirectionTypeResponseEnum = keyof typeof CameraPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type CameraPagingDirectionTypeRequestEnum = Exclude<CameraPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum CameraPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  UID = "UID",
}
/**
 * Справочник типов значений сортировки.
 */
export type CameraPagingOrderByTypeResponseEnum = keyof typeof CameraPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type CameraPagingOrderByTypeRequestEnum = Exclude<CameraPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum CameraRoomPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type CameraRoomPagingDirectionTypeResponseEnum = keyof typeof CameraRoomPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type CameraRoomPagingDirectionTypeRequestEnum = Exclude<CameraRoomPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum CameraRoomPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору камеры
   */
  CAMERA_UID = "CAMERA_UID",
  /**
   * По ОРПОН и номеру квартиры
   */
  ORPON_ROOM_NUMBER = "ORPON_ROOM_NUMBER",
}
/**
 * Справочник типов значений сортировки.
 */
export type CameraRoomPagingOrderByTypeResponseEnum = keyof typeof CameraRoomPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type CameraRoomPagingOrderByTypeRequestEnum = Exclude<CameraRoomPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Камера
 */
export type CameraRequestDto = {
  /**
   * Идентификатор камеры
   */
  id?: string
  /**
   * MAC-адрес камеры
   */
  mac?: string
  /**
   * Тип камеры
   */
  type: CameraTypeRequestEnum
  /**
   * Идентификатор категории.
   * Камера - 1, домофон - 2, скуд - 3, шлагбаум - 4
   */
  cameraCategoryId: number
  /**
   * РТСП-ссылка
   */
  rtspUrl: string
  /**
   * Серийный номер
   */
  serialNumber: string
  /**
   * Идентификатор компании
   */
  companyId: number
}
/**
 * Камера
 */
export type CameraResponseDto = {
  /**
   * Идентификатор камеры
   */
  readonly id: string
  /**
   * uid камеры
   */
  readonly uid: string
  /**
   * Название камеры
   */
  readonly name: string
  /**
   * Признак: онлайн камера или нет
   */
  readonly isOnline: boolean
  /**
   * Признак: Есть ли у камеры активный пользователь
   */
  readonly isActiveUserCamera: boolean
  /**
   * Дата и время изменения статуса камеры
   */
  readonly statusChangedAt: string | null
  /**
   * MAC-адрес камеры
   */
  mac: string
  /**
   * IP камеры
   */
  readonly ip: string
  /**
   * Внешний IP камеры
   */
  readonly remoteIp: string
  /**
   * Дата начала действия текущего тарифа
   */
  readonly tariffStartedAt: string | null
  /**
   * Дата окончания действия текущего тарифа
   */
  readonly tariffEndedAt: string | null
  /**
   * Наименование тарифа
   */
  readonly tariffTitle: string
}
/**
 * Ошибки валидации
 */
export type CameraValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Поле rtsp_url должно быть заполнено
   */
  readonly rtspUrlRequired: CameraValidationErrorRtspUrlRequiredRequestDto
  /**
   * Только одно поле обязательно к заполнению mac или serial_number
   */
  readonly oneFieldMacOrSerialNumberRequired: CameraValidationErrorOneFieldMacOrSerialNumberRequiredRequestDto
}>
/**
 * Ошибки валидации
 */
export type CameraValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Поле rtsp_url должно быть заполнено
   */
  readonly rtspUrlRequired: CameraValidationErrorRtspUrlRequiredResponseDto
  /**
   * Только одно поле обязательно к заполнению mac или serial_number
   */
  readonly oneFieldMacOrSerialNumberRequired: CameraValidationErrorOneFieldMacOrSerialNumberRequiredResponseDto
}>
/**
 * Только одно поле обязательно к заполнению mac или serial_number.
 * Для камер с типом VIOLET и DVR
 */
export type CameraValidationErrorOneFieldMacOrSerialNumberRequiredRequestDto = {
}
/**
 * Только одно поле обязательно к заполнению mac или serial_number.
 * Для камер с типом VIOLET и DVR
 */
export type CameraValidationErrorOneFieldMacOrSerialNumberRequiredResponseDto = {
}
/**
 * Поле rtsp_url должно быть заполнено.
 * Только для камер с типом ROSE
 */
export type CameraValidationErrorRtspUrlRequiredRequestDto = {
}
/**
 * Поле rtsp_url должно быть заполнено.
 * Только для камер с типом ROSE
 */
export type CameraValidationErrorRtspUrlRequiredResponseDto = {
}
/**
 * Фильтр камер
 */
export type CameraFilterRequestDto = {
  /**
   * Признак активности камеры
   */
  isActive?: boolean | null
  /**
   * Признак активности канала
   */
  isChannelAlive?: boolean | null
  /**
   * Статус камеры
   */
  isOnline?: boolean | null
  /**
   * Тип камеры
   */
  cameraType?: CameraTypeResponseEnum
}
/**
 * Фильтр камер
 */
export type CameraFilterResponseDto = {
  /**
   * Признак активности камеры
   */
  isActive: boolean | null
  /**
   * Признак активности канала
   */
  isChannelAlive: boolean | null
  /**
   * Статус камеры
   */
  isOnline: boolean | null
  /**
   * Тип камеры
   */
  cameraType: CameraTypeResponseEnum
}
/**
 * Постраничный вывод
 */
export type CameraPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию
   */
  orderByType?: CameraPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: CameraPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CameraPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию
   */
  orderByType: CameraPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: CameraPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Связь камеры и квартиры
 */
export type CameraRoomRequestDto = {
  /**
   * Идентификатор камеры
   */
  cameraUid: string
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Связь камеры и квартиры
 */
export type CameraRoomResponseDto = {
  /**
   * Идентификатор камеры
   */
  cameraUid: string
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Фильтр связок камеры и квартиры.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type CameraRoomFilterRequestDto = {
  /**
   * По Идентификаторам камер.
   * # Диапазон: 0..100
   */
  cameraUids?: string[]
  /**
   * По ОРПОНам.
   * # Диапазон: 0..100
   */
  orpons?: string[]
  /**
   * По квартирам.
   * # Диапазон: 0..100
   */
  roomNumbers?: string[]
}
/**
 * Фильтр связок камеры и квартиры.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type CameraRoomFilterResponseDto = {
  /**
   * По Идентификаторам камер.
   * # Диапазон: 0..100
   */
  cameraUids: string[]
  /**
   * По ОРПОНам.
   * # Диапазон: 0..100
   */
  orpons: string[]
  /**
   * По квартирам.
   * # Диапазон: 0..100
   */
  roomNumbers: string[]
}
/**
 * Постраничный вывод
 */
export type CameraRoomPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию CAMERA_UID
   */
  orderByType?: CameraRoomPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: CameraRoomPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CameraRoomPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию CAMERA_UID
   */
  orderByType: CameraRoomPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: CameraRoomPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ограничение выборки камер
 */
export type CameraScopeRequestDto = {
  /**
   * Внешний идентификатор компании
   */
  vcCompanyId?: number
}
/**
 * Ограничение выборки камер
 */
export type CameraScopeResponseDto = {
  /**
   * Внешний идентификатор компании
   */
  vcCompanyId: number
}
/**
 * Запрос удаления камеры
 */
export type DeleteCameraRequestDto = {
  /**
   * Идентификатор камеры в vcfront.
   * # Тип: Guid
   */
  uid: string
  /**
   * Флаг полного (безвозвратного) удаления камеры
   */
  isDeletePermanently?: boolean
}
/**
 * Ответ на запрос удаления камеры
 */
export type DeleteCameraResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteCameraResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCameraResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCameraResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка камер
 */
export type GetCameraListRequestDto = {
  /**
   * Ограничение выборки
   */
  scope?: CameraScopeRequestDto | null
  /**
   * Фильтр
   */
  filter?: CameraFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: CameraPagingRequestDto
}>
/**
 * Ответ на получение списка камер
 */
export type GetCameraListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Список
   */
  readonly data: GetCameraListResponseDataDto
  /**
   * Ошибка
   */
  readonly error: GetCameraListResponseErrorDto
}>
/**
 * Список
 */
export type GetCameraListResponseDataDto = {
  /**
   * Список Camera
   */
  items: CameraResponseDto[]
  /**
   * Всего количество
   */
  total: number
}
/**
 * Ошибка запроса
 */
export type GetCameraListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения камеры
 */
export type GetCameraRequestDto = {
  /**
   * Ограничение выборки
   */
  scope: CameraScopeRequestDto
  /**
   * uid камеры
   */
  uid: string
}
/**
 * Ответ на запрос получения камеры
 */
export type GetCameraResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Камера
   */
  readonly data: CameraResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCameraResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества связей камеры и квартиры
 */
export type GetCameraRoomCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: CameraRoomFilterRequestDto | null
}
/**
 * Ответ получения количества связей камеры и квартиры
 */
export type GetCameraRoomCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetCameraRoomCountResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraRoomCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraRoomCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка связей камеры и квартиры
 */
export type GetCameraRoomListRequestDto = {
  /**
   * Фильтр
   */
  filter?: CameraRoomFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: CameraRoomPagingRequestDto
}>
/**
 * Ответ получения списка связей камеры и квартиры
 */
export type GetCameraRoomListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь камеры и квартиры
   */
  readonly data: CameraRoomResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCameraRoomListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraRoomListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraRoomListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения камеры
 */
export type GetCameraRtspUrlExternalIdRequestDto = {
  /**
   * Идентификатор камеры в vcfront.
   * # Тип: Guid
   */
  externalId: string
}
/**
 * Ответ на запрос получения RTSP-ссылки по идентификатору камеры в vcfront
 */
export type GetCameraRtspUrlExternalIdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * RTSP-ссылка
   */
  readonly data: GetCameraRtspUrlExternalIdResponseCameraRtspUrlDto
  /**
   * Ошибка
   */
  readonly error: GetCameraRtspUrlExternalIdResponseErrorDto
}>
/**
 * RTSP-ссылка
 */
export type GetCameraRtspUrlExternalIdResponseCameraRtspUrlDto = {
  /**
   * RTSP-ссылка
   */
  rtspUrl: string
}
/**
 * Ошибка запроса получения списка камер
 */
export type GetCameraRtspUrlExternalIdResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка камер
 */
export type GetCameraRtspUrlExternalIdResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос создания камеры
 */
export type PostCameraRequestDto = {
  /**
   * Камера
   */
  data: CameraRequestDto
}
/**
 * Ответ на запрос создания камеры
 */
export type PostCameraResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostCameraResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostCameraResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка валидации
   */
  readonly cameraValidation: CameraValidationErrorRequestDto
  /**
   * Ошибка в сервисе ВН
   */
  readonly vc: PostCameraResponseErrorVcErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostCameraResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка валидации
   */
  readonly cameraValidation: CameraValidationErrorResponseDto
  /**
   * Ошибка в сервисе ВН
   */
  readonly vc: PostCameraResponseErrorVcErrorDto
}>
/**
 * Ошибка в сервисе ВН
 */
export type PostCameraResponseErrorVcErrorRequestDto = {
  /**
   * Текст ошибки
   */
  text?: string
}
/**
 * Ошибка в сервисе ВН
 */
export type PostCameraResponseErrorVcErrorDto = {
  /**
   * Текст ошибки
   */
  text: string
}
/**
 * Запрос пакетной привязки камер и квартир
 */
export type PutCameraRoomAttachListRequestDto = {
  /**
   * Массив связей Camera и Room
   */
  data?: CameraRoomRequestDto[]
}
/**
 * Ответ на запрос пакетной привязки камер и квартир
 */
export type PutCameraRoomAttachListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutCameraRoomAttachListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomAttachListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomAttachListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос привязки камеры и квартиры
 */
export type PutCameraRoomAttachRequestDto = {
  /**
   * Связь Camera и Room
   */
  data: CameraRoomRequestDto
}
/**
 * Ответ привязки камеры и квартиры
 */
export type PutCameraRoomAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutCameraRoomAttachResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос пакетной отвязки камер и квартир
 */
export type PutCameraRoomDetachListRequestDto = {
  /**
   * Массив связей Camera и Room
   */
  data?: CameraRoomRequestDto[]
}
/**
 * Ответ на запрос пакетной отвязки камер и квартир
 */
export type PutCameraRoomDetachListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutCameraRoomDetachListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomDetachListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomDetachListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос отвязки камеры и квартиры
 */
export type PutCameraRoomDetachRequestDto = {
  /**
   * Связь Camera и Room
   */
  data: CameraRoomRequestDto
}
/**
 * Ответ отвязки камеры и квартиры
 */
export type PutCameraRoomDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutCameraRoomDetachResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PutCameraRoomDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Камера
   */
  "Camera": {
    "kind": "class",
    "text": "Камера",
    "fields": {
      /**
       * Идентификатор камеры
       */
      "id": {
        "type": "string",
        "text": "Идентификатор камеры",
      },
      /**
       * uid камеры
       */
      "uid": {
        "type": "string",
        "text": "uid камеры",
      },
      /**
       * Название камеры
       */
      "name": {
        "type": "string",
        "text": "Название камеры",
      },
      /**
       * Признак: онлайн камера или нет
       */
      "isOnline": {
        "type": "bool",
        "text": "Признак: онлайн камера или нет",
      },
      /**
       * Признак: Есть ли у камеры активный пользователь
       */
      "isActiveUserCamera": {
        "type": "bool",
        "text": "Признак: Есть ли у камеры активный пользователь",
      },
      /**
       * Дата и время изменения статуса камеры
       */
      "statusChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время изменения статуса камеры",
      },
      /**
       * MAC-адрес камеры
       */
      "mac": {
        "type": "string",
        "text": "MAC-адрес камеры",
      },
      /**
       * IP камеры
       */
      "ip": {
        "type": "string",
        "text": "IP камеры",
      },
      /**
       * Внешний IP камеры
       */
      "remoteIp": {
        "type": "string",
        "text": "Внешний IP камеры",
      },
      /**
       * Дата начала действия текущего тарифа
       */
      "tariffStartedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата начала действия текущего тарифа",
      },
      /**
       * Дата окончания действия текущего тарифа
       */
      "tariffEndedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата окончания действия текущего тарифа",
      },
      /**
       * Наименование тарифа
       */
      "tariffTitle": {
        "type": "string",
        "text": "Наименование тарифа",
      },
      /**
       * Тип камеры
       */
      "type": {
        "type": "Camera.Type",
        "text": "Тип камеры",
      },
      /**
       * Идентификатор категории.
       * Камера - 1, домофон - 2, скуд - 3, шлагбаум - 4
       */
      "cameraCategoryId": {
        "type": "int32",
        "text": "Идентификатор категории.\nКамера - 1, домофон - 2, скуд - 3, шлагбаум - 4",
      },
      /**
       * РТСП-ссылка
       */
      "rtspUrl": {
        "type": "string",
        "text": "РТСП-ссылка",
      },
      /**
       * Серийный номер
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер",
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании",
      },
    },
  },
  /**
   * Ошибки валидации
   */
  "Camera.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации",
    "fields": {
      /**
       * Поле rtsp_url должно быть заполнено
       */
      "rtspUrlRequired": {
        "type": "Camera.ValidationError.RtspUrlRequired",
        "text": "Поле rtsp_url должно быть заполнено",
      },
      /**
       * Только одно поле обязательно к заполнению mac или serial_number
       */
      "oneFieldMacOrSerialNumberRequired": {
        "type": "Camera.ValidationError.OneFieldMacOrSerialNumberRequired",
        "text": "Только одно поле обязательно к заполнению mac или serial_number",
      },
    },
  },
  /**
   * Только одно поле обязательно к заполнению mac или serial_number.
   * Для камер с типом VIOLET и DVR
   */
  "Camera.ValidationError.OneFieldMacOrSerialNumberRequired": {
    "kind": "class",
    "text": "Только одно поле обязательно к заполнению mac или serial_number.\nДля камер с типом VIOLET и DVR",
  },
  /**
   * Поле rtsp_url должно быть заполнено.
   * Только для камер с типом ROSE
   */
  "Camera.ValidationError.RtspUrlRequired": {
    "kind": "class",
    "text": "Поле rtsp_url должно быть заполнено.\nТолько для камер с типом ROSE",
  },
  /**
   * Фильтр камер
   */
  "CameraFilter": {
    "kind": "class",
    "text": "Фильтр камер",
    "fields": {
      /**
       * Признак активности камеры
       */
      "isActive": {
        "type": "google.protobuf.BoolValue",
        "text": "Признак активности камеры",
      },
      /**
       * Признак активности канала
       */
      "isChannelAlive": {
        "type": "google.protobuf.BoolValue",
        "text": "Признак активности канала",
      },
      /**
       * Статус камеры
       */
      "isOnline": {
        "type": "google.protobuf.BoolValue",
        "text": "Статус камеры",
      },
      /**
       * Тип камеры
       */
      "cameraType": {
        "type": "Camera.Type",
        "text": "Тип камеры",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "CameraPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию
       */
      "orderByType": {
        "type": "CameraPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "CameraPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Связь камеры и квартиры
   */
  "CameraRoom": {
    "kind": "class",
    "text": "Связь камеры и квартиры",
    "fields": {
      /**
       * Идентификатор камеры
       */
      "cameraUid": {
        "type": "string",
        "text": "Идентификатор камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
    },
  },
  /**
   * Фильтр связок камеры и квартиры.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "CameraRoomFilter": {
    "kind": "class",
    "text": "Фильтр связок камеры и квартиры.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификаторам камер.
       * # Диапазон: 0..100
       */
      "cameraUids": {
        "type": "string",
        "text": "По Идентификаторам камер.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * По ОРПОНам.
       * # Диапазон: 0..100
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * По квартирам.
       * # Диапазон: 0..100
       */
      "roomNumbers": {
        "type": "string",
        "text": "По квартирам.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "CameraRoomPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию CAMERA_UID
       */
      "orderByType": {
        "type": "CameraRoomPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию CAMERA_UID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "CameraRoomPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ограничение выборки камер
   */
  "CameraScope": {
    "kind": "class",
    "text": "Ограничение выборки камер",
    "fields": {
      /**
       * Внешний идентификатор компании
       */
      "vcCompanyId": {
        "type": "int32",
        "text": "Внешний идентификатор компании",
      },
    },
  },
  /**
   * Запрос удаления камеры
   */
  "DeleteCameraRequest": {
    "kind": "class",
    "text": "Запрос удаления камеры",
    "fields": {
      /**
       * Идентификатор камеры в vcfront.
       * # Тип: Guid
       */
      "uid": {
        "type": "string",
        "text": "Идентификатор камеры в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Флаг полного (безвозвратного) удаления камеры
       */
      "isDeletePermanently": {
        "type": "bool",
        "text": "Флаг полного (безвозвратного) удаления камеры",
      },
    },
  },
  /**
   * Ответ на запрос удаления камеры
   */
  "DeleteCameraResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления камеры",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteCameraResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteCameraResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка камер
   */
  "GetCameraListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка камер",
    "fields": {
      /**
       * Ограничение выборки
       */
      "scope": {
        "type": "CameraScope",
        "text": "Ограничение выборки",
      },
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraFilter",
        "text": "Фильтр",
      },
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "CameraPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка камер
   */
  "GetCameraListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка камер",
    "fields": {
      /**
       * Список
       */
      "data": {
        "type": "GetCameraListResponse.Data",
        "text": "Список",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Список
   */
  "GetCameraListResponse.Data": {
    "kind": "class",
    "text": "Список",
    "fields": {
      /**
       * Список Camera
       */
      "items": {
        "type": "Camera",
        "text": "Список Camera",
      },
      /**
       * Всего количество
       */
      "total": {
        "type": "int32",
        "text": "Всего количество",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения камеры
   */
  "GetCameraRequest": {
    "kind": "class",
    "text": "Запрос получения камеры",
    "fields": {
      /**
       * Ограничение выборки
       */
      "scope": {
        "type": "CameraScope",
        "text": "Ограничение выборки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * uid камеры
       */
      "uid": {
        "type": "string",
        "text": "uid камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения камеры
   */
  "GetCameraResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения камеры",
    "fields": {
      /**
       * Камера
       */
      "data": {
        "type": "Camera",
        "text": "Камера",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества связей камеры и квартиры
   */
  "GetCameraRoomCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей камеры и квартиры",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraRoomFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ получения количества связей камеры и квартиры
   */
  "GetCameraRoomCountResponse": {
    "kind": "class",
    "text": "Ответ получения количества связей камеры и квартиры",
    "fields": {
      /**
       * Всего количество
       */
      "data": {
        "type": "int32",
        "text": "Всего количество",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraRoomCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraRoomCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка связей камеры и квартиры
   */
  "GetCameraRoomListRequest": {
    "kind": "class",
    "text": "Запрос получения списка связей камеры и квартиры",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraRoomFilter",
        "text": "Фильтр",
      },
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "CameraRoomPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ получения списка связей камеры и квартиры
   */
  "GetCameraRoomListResponse": {
    "kind": "class",
    "text": "Ответ получения списка связей камеры и квартиры",
    "fields": {
      /**
       * Связь камеры и квартиры
       */
      "data": {
        "type": "CameraRoom",
        "text": "Связь камеры и квартиры",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraRoomListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraRoomListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения камеры
   */
  "GetCameraRtspUrlExternalIdRequest": {
    "kind": "class",
    "text": "Запрос получения камеры",
    "fields": {
      /**
       * Идентификатор камеры в vcfront.
       * # Тип: Guid
       */
      "externalId": {
        "type": "string",
        "text": "Идентификатор камеры в vcfront.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения RTSP-ссылки по идентификатору камеры в vcfront
   */
  "GetCameraRtspUrlExternalIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения RTSP-ссылки по идентификатору камеры в vcfront",
    "fields": {
      /**
       * RTSP-ссылка
       */
      "data": {
        "type": "GetCameraRtspUrlExternalIdResponse.CameraRtspUrl",
        "text": "RTSP-ссылка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraRtspUrlExternalIdResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * RTSP-ссылка
   */
  "GetCameraRtspUrlExternalIdResponse.CameraRtspUrl": {
    "kind": "class",
    "text": "RTSP-ссылка",
    "fields": {
      /**
       * RTSP-ссылка
       */
      "rtspUrl": {
        "type": "string",
        "text": "RTSP-ссылка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка камер
   */
  "GetCameraRtspUrlExternalIdResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка камер",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания камеры
   */
  "PostCameraRequest": {
    "kind": "class",
    "text": "Запрос создания камеры",
    "fields": {
      /**
       * Камера
       */
      "data": {
        "type": "Camera",
        "text": "Камера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания камеры
   */
  "PostCameraResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания камеры",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostCameraResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostCameraResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка валидации
       */
      "cameraValidation": {
        "type": "Camera.ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка в сервисе ВН
       */
      "vc": {
        "type": "PostCameraResponse.Error.VcError",
        "text": "Ошибка в сервисе ВН",
      },
    },
  },
  /**
   * Ошибка в сервисе ВН
   */
  "PostCameraResponse.Error.VcError": {
    "kind": "class",
    "text": "Ошибка в сервисе ВН",
    "fields": {
      /**
       * Текст ошибки
       */
      "text": {
        "type": "string",
        "text": "Текст ошибки",
      },
    },
  },
  /**
   * Запрос пакетной привязки камер и квартир
   */
  "PutCameraRoomAttachListRequest": {
    "kind": "class",
    "text": "Запрос пакетной привязки камер и квартир",
    "fields": {
      /**
       * Массив связей Camera и Room
       */
      "data": {
        "type": "CameraRoom",
        "text": "Массив связей Camera и Room",
      },
    },
  },
  /**
   * Ответ на запрос пакетной привязки камер и квартир
   */
  "PutCameraRoomAttachListResponse": {
    "kind": "class",
    "text": "Ответ на запрос пакетной привязки камер и квартир",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutCameraRoomAttachListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PutCameraRoomAttachListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос привязки камеры и квартиры
   */
  "PutCameraRoomAttachRequest": {
    "kind": "class",
    "text": "Запрос привязки камеры и квартиры",
    "fields": {
      /**
       * Связь Camera и Room
       */
      "data": {
        "type": "CameraRoom",
        "text": "Связь Camera и Room",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ привязки камеры и квартиры
   */
  "PutCameraRoomAttachResponse": {
    "kind": "class",
    "text": "Ответ привязки камеры и квартиры",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutCameraRoomAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PutCameraRoomAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос пакетной отвязки камер и квартир
   */
  "PutCameraRoomDetachListRequest": {
    "kind": "class",
    "text": "Запрос пакетной отвязки камер и квартир",
    "fields": {
      /**
       * Массив связей Camera и Room
       */
      "data": {
        "type": "CameraRoom",
        "text": "Массив связей Camera и Room",
      },
    },
  },
  /**
   * Ответ на запрос пакетной отвязки камер и квартир
   */
  "PutCameraRoomDetachListResponse": {
    "kind": "class",
    "text": "Ответ на запрос пакетной отвязки камер и квартир",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutCameraRoomDetachListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PutCameraRoomDetachListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос отвязки камеры и квартиры
   */
  "PutCameraRoomDetachRequest": {
    "kind": "class",
    "text": "Запрос отвязки камеры и квартиры",
    "fields": {
      /**
       * Связь Camera и Room
       */
      "data": {
        "type": "CameraRoom",
        "text": "Связь Camera и Room",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ отвязки камеры и квартиры
   */
  "PutCameraRoomDetachResponse": {
    "kind": "class",
    "text": "Ответ отвязки камеры и квартиры",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutCameraRoomDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PutCameraRoomDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов камер
   */
  "Camera.Type": {
    "kind": "enum",
    "text": "Справочник типов камер",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Регистратор
       */
      "DVR": {
        "i": 1,
        "text": "Регистратор",
      },
      /**
       * Система управления видео
       */
      "VMS": {
        "i": 2,
        "text": "Система управления видео",
      },
      /**
       * RTSP-камера
       */
      "ROSE": {
        "i": 3,
        "text": "RTSP-камера",
      },
      /**
       * IP-камера
       */
      "VIOLET": {
        "i": 4,
        "text": "IP-камера",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "CameraPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "CameraPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "UID": {
        "i": 1,
        "text": "По идентификатору",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "CameraRoomPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "CameraRoomPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору камеры
       */
      "CAMERA_UID": {
        "i": 1,
        "text": "По Идентификатору камеры",
      },
      /**
       * По ОРПОН и номеру квартиры
       */
      "ORPON_ROOM_NUMBER": {
        "i": 2,
        "text": "По ОРПОН и номеру квартиры",
      },
    },
  },
}